// 求人データベース用の共通定数

// ソートオプション
// 作成順は OpenSearch の mapping に created_at を持たないため、連番 id を作成順の代理として使う
// （ALLOWED_SORT_COLUMNS / 求人管理画面 SearchForm と揃える / Issue #2629）。ラベルは「作成が〜」のまま。
export const ORDER_ITEMS = [
  { value: 'updated_at:desc', label: '更新が新しい順' },
  { value: 'updated_at:asc', label: '更新が古い順' },
  { value: 'id:desc', label: '作成が新しい順' },
  { value: 'id:asc', label: '作成が古い順' },
  { value: 'fee_rate:desc', label: '成約料率が高い順' },
  { value: 'fee_value:desc', label: '成約報酬が高い順' },
] as const;

// 都道府県リスト
export const AREAS = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
] as const;

// 都道府県コード絞り込み用マスタ（JIS X 0401 順、code 1=北海道〜47=沖縄県。jp_prefecture コードと一致。Issue #3394）
export const PREFECTURES: { code: number; name: string }[] = AREAS.map((name, index) => ({
  code: index + 1,
  name,
}));

// 雇用形態（Rails の SharedJobPost employment_type enum と一致。Issue #3216）
export const EMPLOYMENT_TYPES: { value: string; label: string }[] = [
  { value: 'full_time', label: '正社員' },
  { value: 'contract', label: '契約社員' },
  { value: 'outsourcing', label: '業務委託' },
  { value: 'dispatch', label: '派遣' },
  { value: 'part_time', label: 'アルバイト・パート' },
  { value: 'other', label: 'その他' },
];

// 最終学歴（候補者の学歴として選ばせる選択肢のため、求人側のみが持つ `none`（学歴不問）は含めない。Issue #3216）
export const EDUCATION_LEVELS: { value: string; label: string }[] = [
  { value: 'junior_high', label: '中学卒業' },
  { value: 'high_school', label: '高校卒業' },
  { value: 'vocational_or_junior_college', label: '専門・短大卒業' },
  { value: 'university', label: '大学卒業' },
  { value: 'graduate', label: '大学院卒業' },
];
